<template>
  <div>Commands works !</div>
</template>

<script>
export default {
  name: 'Commands',
}
</script>

<style>

</style>
